export const RESET_STORE = 'app/resetStore';

export const resetStore = () => ({ type: RESET_STORE }) as const;
